
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Questo è portato dal progetto
                    <a href="${0}">Folksonomy Engine</a>. Non
                    esitare a partecipare o dare feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Questo strumento ti permette di correggere l'elenco degli ingredienti. Puoi aggiungere, rimuovere o modificare l'elenco degli ingredienti di
                .
                <br>
                Questo carattere <span class="highlight">␣</span> rappresenta uno spazio.
                <br>
                Questo carattere <span class="highlight">↩︎</span> rappresenta un'interruzione di riga. `,
'hb28f1f2ec1744ee9': html`Queste proprietà vengono create e archiviate dagli utenti per qualsiasi tipo di utilizzo. Sentiti
                    libero di aggiungere le tue. Le proprietà e i valori che crei
                    <strong>devono essere reali</strong>. Puoi approfondire
                    <a href="${0}">l'elenco delle proprietà già utilizzate dalla community</a>
                    o esplorare la
                    <a href="${1}">documentazione delle proprietà e il relativo motore di ricerca</a>.`,
's000a5b76bd3a01c2': `Caricamento proprietà in corso...`,
's000d98595e959c1e': `Disponibile su Google Play`,
's013bdc8cf0d3583d': `Aiutaci per gli ingredienti`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Convalida il raccolto`,
's03e9c8114521b998': `Modificherò gli ingredienti`,
's05ec315d9308091a': `Icona degli angoli del codice a barre`,
's061eb5af92512c85': `Salvato! Puoi aiutarmi con un altro?`,
's06847c221c4c0bc1': `Vorrei creare una proprietà per [descrivere il tuo caso d'uso]...`,
's06f6c6f99db6b552': `Originale`,
's081e2ad82db71e1d': `Valori raggruppati`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `documentazione dedicata`,
's0bb2d48532acc455': `Scarica CSV`,
's0d5b7fee0311db68': `Proprietà`,
's0fb218abc2e157ed': `Invalida l'immagine`,
's100c4928cc74642a': `sostenere il progresso della ricerca sulla salute pubblica.`,
's10db5498186c083b': `Annulla ritaglio`,
's11a18a69b30b65ed': `Aiutaci a correggere gli errori nell'elenco degli ingredienti`,
's1205d5f6fccf8e69': `Valore della proprietà`,
's15d64a0a6715285a': `Nuova chiave`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Area di selezione`,
's1a52515ec8ddade8': `Codice a barre del prodotto`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Aiutaci a correggere le informazioni nutrizionali`,
's1e00019dc454872d': `Fornire un nome di proprietà utilizzando l'attributo property-name.`,
's1e49126af0935a5b': `Elenco dei prodotti che utilizzano questa proprietà`,
's21e73088de6f26f3': `Disponibile su App Store`,
's255857544a9d5ec0': `Ripristina`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Annulla`,
's2db7b654c0a9bde0': `Documentare la proprietà`,
's300b3a6ee4e1252d': str`Corrispondenza scarsa ${0}%`,
's33f786bb6b4f0cf4': `Risultato del raccolto`,
's33f85f24c0f5f008': `Salva`,
's34be4af4e8fec4ae': `Chiedi prima alla comunità`,
's36d86adc823cbfa6': `Prima di creare una nuova proprietà, discutine con la community:`,
's3781d25aa51a736c': `Documentazione del motore Folksonomia`,
's383ae4449428b61e': `Ripristina ritaglio`,
's39bcf88721a1e8ee': `Reimposta selezione`,
's39e14e14300694c7': `Documentazione e linee guida`,
's3b430cfa5c1fe7f4': str`Documentazione per ${0}`,
's3f4e4b52f230a892': `Immagine su tela`,
's417b90913e05bc17': `Anteprima`,
's41f7dca46d3f1b4a': `Valore`,
's422bba9636ce2489': `Immagine centrale`,
's42dd66b2441566fd': `Icona centrale`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Aggiungi un nutriente`,
's453ab0dbb9b5c777': `Ridimensiona a destra`,
's475b08749d0706ed': `Aiutaci a informare milioni di consumatori in tutto il mondo su ciò che mangiano`,
's49730f3d5751a433': `Scaricamento...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Numero di prodotti`,
's4df2f533c0c1e7d0': `Controlli dell'immagine`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Sposta selezione`,
's4f751fb9b3ed766c': `Creazione di una nuova proprietà`,
's547c12ae169d00bc': `Disponibile su F-Droid`,
's5560fb119e40923d': `Inserisci il nome della proprietà...`,
's55d7249883a98ca1': `informazioni su questa proprietà su Open Food Facts wiki`,
's565867d84c04aea2': `Proprietà del filtro...`,
's5666afe5cd0166de': `Si prega di correggere gli errori o modificare il testo prima di confermare`,
's57472465a23b41db': `Valori`,
's58e1eeea7a60ae51': `Caricamento prodotti in corso...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Aiutaci a correggere le informazioni nutrizionali.`,
's5dd6f12783fca34f': `Modifica l'elenco degli ingredienti`,
's5e8250fb85d64c23': `Chiudi`,
's5ed03bb1f3a15949': `Foto`,
's6306a31415aea913': `SOSTENGO`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Modifica`,
's66413c24dcf680e2': `Salta`,
's67ae6594857a4d57': `Grazie per il tuo contributo!`,
's6cee7cad81dfedd1': `Immagine ritagliata`,
's6d7b6cdedaadfb6e': `Ogni donazione conta! Apprezziamo il tuo supporto nel portare maggiore trasparenza alimentare nel mondo.`,
's7124dde792a8faa2': `APK Android`,
's718dea04853f80ae': str`Buona corrispondenza ${0}%`,
's71a5c9f4b68ef4d4': `Quantità`,
's74cb3d66f6a668e1': `Documentazione`,
's787dd11bed0dc88a': `Ridimensiona a sinistra`,
's7ce4fd9430e80cea': `valore`,
's801a05fa8e881f37': `Scopri di più sulla creazione di proprietà e sulle linee guida:`,
's8038273de2cf8b73': `Seleziona un'area da ritagliare.`,
's839cc2908a5387f2': `Filtra codici a barre...`,
's86197dcf3e96af64': `Sfoglia e cerca le proprietà esistenti`,
's8a63be30a129a59c': `Ridimensiona in basso`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Ridimensiona in alto a destra`,
's8db84aa4bc949af2': `Documentare la nuova proprietà`,
's8f839a03997a16d7': `Visualizza prodotto`,
's901ae1e236ac45d3': `Annulla eliminazione`,
's907f7a97c6b29425': `Si prega di notare che il modello di dati potrebbe essere modificato. L'utilizzo è a proprio rischio e pericolo.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingredienti:`,
's9a7f60fce090ecaf': `Impossibile caricare le proprietà. Riprova più tardi.`,
's9b87abd68fb9df45': `Non trovato? Crea una nuova chiave {value}`,
's9c0f52425fd2f07e': `Potrebbe non corrispondere`,
's9fc41f789c63b40d': `Prodotti`,
'sa1fa766e0d5634d7': `Nessun punteggio disponibile`,
'sa548778b24054030': `Esplora tutte le proprietà fornite dal progetto Folksonomy Engine. Queste proprietà forniscono metadati e approfondimenti aggiuntivi sui prodotti nel database Open Food Facts.`,
'sa63907958bd0ec4b': `Ridimensiona in alto a sinistra`,
'sa95b4224f685a36a': `Chiudi modale`,
'sab56a1d439576fd6': `Icona suggerimento`,
'sac47ea2901d04c15': `Ridimensiona in basso a sinistra`,
'sb125227d436c2925': `Cerca il tuo concetto immobiliare nel database immobiliare esistente:`,
'sb125568d43642e6f': `Rispondere alle domande sul prodotto.`,
'sb1c538e038f9b214': str`Ottima corrispondenza ${0}%`,
'sb28639570ff3b852': `elenco di tutte le proprietà`,
'sb3bdd638a58d30f4': `coinvolgere la comunità di cittadini attivi,`,
'sb3cbcc1bd0fff140': `Dopo aver verificato che la tua proprietà non esiste e che la comunità concorda sulla sua utilità, devi prima documentarla nel wiki.`,
'sb3d4f79d9d8b71e5': `Invia`,
'sb560fa37a7bfb6c2': `Nessun prodotto trovato per questa proprietà.`,
'sb7f72e4c8a2d3357': `Filtra i valori...`,
'sb8178320160f84ea': `Mostra raccolto`,
'sbad7d2734149470b': `Convalida`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Abbiamo risposto a tutte le vostre domande! Grazie per il vostro aiuto!`,
'sbd9a0b2293b3cd3c': `Porzione`,
'sbe472dc3c2685985': `Valore corrispondente`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Ridimensiona la parte superiore`,
'sc1c08d0cbcc3bd24': `Non corrisponde`,
'sc52696641af72b53': `Installa l'app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Correzione suggerita`,
'sc681b137e8f604f7': `Conferma eliminazione`,
'sc6daf8a31883f8b9': `Sposta immagine`,
'sc895972c88d38ca5': `Proprietà della folksonomia`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Righe`,
'scb3b0671d7b7f640': `Nuovo valore`,
'scb489a1a173ac3f0': `Sì`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Partecipa alla discussione su Slack`,
'scdb6cad0b92721bf': `Nessuna proprietà trovata.`,
'scf23a05631f93732': `Conferma Elimina`,
'scfed2f270ef6a3aa': `Seleziona l'area`,
'sd1022bc1ef9204f7': `Immagine zoomabile`,
'sd1077c055cf9ba6b': `Aiutaci a convalidare l'elenco degli ingredienti del prodotto.`,
'sd698d21ddecba56b': `Ciao! Puoi aiutarci a migliorare le informazioni sul prodotto rispondendo alle seguenti domande:`,
'sd82bc2decefa621b': `rimanere indipendenti dall'industria alimentare,`,
'sdb97e5976482606e': `Controlla se una proprietà esiste già`,
'sdbf806fefc584115': `Dovresti trovare un`,
'sdc673e73b5c13aea': `Elimina`,
'sdc792b75f1edcaba': `Aiutaci a correggere l'ortografia degli ingredienti.`,
'sdca5deead576ceee': `Ridimensiona in basso a destra`,
'sdcc2555c5dde524f': `Vuoi davvero eliminare questo elemento? Questa azione non può essere annullata.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Invalidare`,
'se5127cf0f92e7e48': `Suggerimento: puoi trovare anche il`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Proporrò un raccolto migliore`,
'seea3800e27baa686': `Prodotti individuali`,
'sefaba4adc4ec9219': `Proprietà della folksonomia`,
'seffa8ca49175b5f0': `Proprietà personalizzate`,
'sf44a6b3b232c28ea': str`Sostituisci il valore corrente con ${0}`,
'sf4cd86a2f5ef2588': `Codice a barre del prodotto`,
'sf57a61152168cc81': `Aiutaci a correggere il rilevamento degli ingredienti`,
'sf88b90b8ba23871c': `Corrispondenza sconosciuta`,
'sf9aee319a006c9b4': `Aggiungi`,
'sfacbbe968fa7d773': `Nome della proprietà:`,
'sfc40ea3d5d5aa6f8': `Le tue donazioni finanziano le attività quotidiane della nostra associazione senza scopo di lucro:`,
'sfe87465d50530725': `Valore corrispondente`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  